/* eslint-disable @typescript-eslint/no-explicit-any */
// @ts-nocheck
/**
 * MetricLabel — wraps a stat label with an InfoTip linked to a glossary
 * term. Use this anywhere a metric appears with a small label above the
 * value.
 *
 * Example:
 *
 *   <div className="bg-bg-base p-4 rounded">
 *     <MetricLabel termId="avg_score">Avg Score</MetricLabel>
 *     <div className="text-2xl text-fg-primary">{score}</div>
 *   </div>
 *
 * For column headers in tables, use <ColumnLabel> for the same effect with
 * sortable-header friendly styling.
 */
import React from 'react';
import { InfoTip } from './InfoTip';

type MetricLabelProps = {
  termId: string;
  children: React.ReactNode;
  className?: string;
  compact?: boolean;
};

export const MetricLabel: React.FC<MetricLabelProps> = ({
  termId,
  children,
  className = '',
  compact = false,
}) => {
  return (
    <div
      className={`text-xs text-fg-muted uppercase tracking-wide font-semibold flex items-center ${className}`}
    >
      <span>{children}</span>
      <InfoTip termId={termId} compact={compact} />
    </div>
  );
};

/**
 * ColumnLabel — variant for use inside <th> elements. No uppercase.
 */
export const ColumnLabel: React.FC<MetricLabelProps> = ({
  termId,
  children,
  className = '',
}) => {
  return (
    <span className={`inline-flex items-center text-fg-secondary ${className}`}>
      <span>{children}</span>
      <InfoTip termId={termId} compact />
    </span>
  );
};

export default MetricLabel;
